import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import SignIn from '../views/SignIn.vue'
import Settings from '../views/Settings.vue'
import GenomicBleed from '../views/GenomicBleed.vue'
import GenomicSamples from '../views/GenomicSamples.vue'
import HealthBleed from '../views/HealthBleed.vue'
import HealthPlates from '../views/HealthPlates.vue'
import LocalStorage from '../views/LocalStorage.vue'
import DocumentList from '../views/DocumentList.vue'
import PdfDocument from '../views/PdfDocument.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/signin',
    name: 'signin',
    component: SignIn
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/index.html',
    name: 'index',
    component: Home
  },
  {
    path: '/genomicbleed',
    name: 'Genomic Bleed',
    component: GenomicBleed
  },
  {
     path: '/genomicbleed',
     name: 'Genomic Check',
     component: GenomicBleed
  },
  {
    path: '/genomicsamples',
    name: 'Genomic Bleeds',
    component: GenomicSamples
  },
  {
    path: '/genomicsamples',
    name: 'Genomic Checks',
    component: GenomicSamples
  },
  {
    path: '/healthbleed',
    name: 'Health Bleed',
    component: HealthBleed
  },
  {
    path: '/healthPlates',
    name: 'Health Bleed (plates)',
    component: HealthPlates
  },
  {
    path: '/localstorage',
    name: 'Local Storage',
    component: LocalStorage
  },
  {
    path: '/documents',
    name: 'Documents',
    component: DocumentList
  },
  {
    path: '/pdfDocument',
    name: 'Document',
    component: PdfDocument
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
})

export default router